import { PaneArea } from '../../types/shared'
import HorizontalLine from '../canvas/horizontal_line'
import { IScaledLineAttrs } from '../canvas/scaled_line'
import PaneModel from '../models/pane'

type Area = PaneArea
type Attrs = IScaledLineAttrs
type PartialAttrs = Partial<Attrs>

class HorizontalLineCreator extends HorizontalLine<Attrs> {
  isCreator = true

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)
    this.toolsCallback = toolsCallback
    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }

  onMouseUp(area: Area) {
    this.attrs.y1 = area.y
    this.attrs.y2 = area.y
    this.release()
    this.replaceMyself(HorizontalLine.fromObject<HorizontalLine>(this.attrs, this.model))
    this.toolsCallback()
  }
}

export default HorizontalLineCreator
